/* 
* <license header>
*/

import React, { useState, useEffect } from 'react'
import { Provider, defaultTheme, View } from '@adobe/react-spectrum'
import ErrorBoundary from 'react-error-boundary'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import { FavoritesProvider } from '../context/FavoritesContext'
import SideBar from './SideBar'
import ActionsForm from './ActionsForm'
import { Home } from './Home'
import { About } from './About'
import { Roadmap } from './Roadmap'
import { AskAssistant } from './AskAssistant'
import { Admin } from './Admin'
import { AppBuilderTypeBrowser } from './AppBuilderTypeBrowser'
import { AppTemplates } from './AppTemplates'
import { OnboardExistingApp } from './OnboardExistingApp'
import { AppBrowserList } from './app-browser/AppBrowserList'
import { AppBrowserDetails } from './app-browser/AppBrowserDetails'
import { Wizard } from './Wizard'

const MOBILE_BREAKPOINT = 768

function App (props) {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < MOBILE_BREAKPOINT
      setIsMobile(mobile)
      if (!mobile) setSidebarOpen(false)
    }
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const closeSidebar = () => setSidebarOpen(false)

  console.log('runtime object:', props.runtime)
  console.log('ims object:', props.ims)

  // use exc runtime event handlers
  // respond to configuration change events (e.g. user switches org)
  props.runtime.on('configuration', ({ imsOrg, imsToken, locale }) => {
    console.log('configuration change', { imsOrg, imsToken, locale })
  })
  // respond to history change events
  props.runtime.on('history', ({ type, path }) => {
    console.log('history change', { type, path })
  })

  return (
    <ErrorBoundary onError={onError} FallbackComponent={fallbackComponent}>
      <Router>
        <FavoritesProvider>
        <Provider theme={defaultTheme} colorScheme={'light'}>
          <div className="AppLayout">
            {isMobile && (
              <>
                <button
                  type="button"
                  className="AppLayout-hamburger"
                  onClick={() => setSidebarOpen(true)}
                  aria-label="Open menu"
                >
                  <span className="AppLayout-hamburgerBar" />
                  <span className="AppLayout-hamburgerBar" />
                  <span className="AppLayout-hamburgerBar" />
                </button>
                {sidebarOpen && (
                  <div
                    className="AppLayout-overlay"
                    onClick={closeSidebar}
                    onKeyDown={(e) => e.key === 'Escape' && closeSidebar()}
                    role="button"
                    tabIndex={0}
                    aria-label="Close menu"
                  />
                )}
              </>
            )}
            <aside
              className={`AppLayout-sidebar ${sidebarOpen ? 'is-open' : ''}`}
              aria-hidden={isMobile && !sidebarOpen}
            >
              {isMobile && (
                <button
                  type="button"
                  className="AppLayout-sidebarClose"
                  onClick={closeSidebar}
                  aria-label="Close menu"
                >
                  ×
                </button>
              )}
              <View padding="size-200" UNSAFE_style={{ height: '100%' }}>
                <SideBar onNavigate={isMobile ? closeSidebar : undefined} />
              </View>
            </aside>
            <main className="AppLayout-content">
              <View
                padding="size-200"
                UNSAFE_style={{
                  backgroundColor: 'var(--white)',
                  minHeight: 0,
                  overflow: 'auto',
                  width: '100%',
                  minWidth: 0
                }}
              >
                <div style={{ width: '100%', minWidth: 0, maxWidth: '100%' }}>
                  <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/ask-assistant' element={<AskAssistant runtime={props.runtime} ims={props.ims} />} />
                    <Route path='/config' element={<Admin />} />
                    <Route path='/onboard' element={<OnboardExistingApp />} />
                    <Route path='/app-types' element={<AppBuilderTypeBrowser />} />
                    <Route path='/app-templates' element={<AppTemplates />} />
                    <Route path='/apps' element={<AppBrowserList />} />
                    <Route path='/apps/:id' element={<AppBrowserDetails />} />
                    <Route path='/wizard' element={<Wizard />} />
                    <Route path='/actions' element={<ActionsForm runtime={props.runtime} ims={props.ims} />} />
                    <Route path='/about' element={<About />} />
                    <Route path='/about/roadmap' element={<Roadmap />} />
                  </Routes>
                </div>
              </View>
            </main>
          </div>
        </Provider>
        </FavoritesProvider>
      </Router>
    </ErrorBoundary>
  )

  // Methods

  // error handler on UI rendering failure
  function onError (e, componentStack) { }

  // component to show if UI fails rendering
  function fallbackComponent ({ componentStack, error }) {
    return (
      <React.Fragment>
        <h1 style={{ textAlign: 'center', marginTop: '20px' }}>
          Something went wrong :(
        </h1>
        <pre>{componentStack + '\n' + error.message}</pre>
      </React.Fragment>
    )
  }
}

export default App
